import { Box } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
// The same horizontal stacked bar the live-pipeline report uses.
import { ChartRenderer } from '@/componentsV1/Charts';
import type { DashboardSection } from '../../../types';

const FONT = 'Inter, system-ui, sans-serif';

export const SplitBar = ({ section }: { section: DashboardSection }) => {
  const segs = section.split ?? [];
  if (segs.length === 0) return null;

  return (
    <Box>
      <ChartRenderer
        chartType="horizontalStackedBar"
        width="100%"
        height="150px"
        data={{ series: segs.map((s) => ({ name: s.label, y: s.pct })) }}
        highchartsOptions={{
          chart: { backgroundColor: 'transparent' },
          credits: { enabled: false },
          title: { text: undefined },
          // Axes carry no information here — the split is the whole story.
          yAxis: {
            title: { text: null },
            labels: { enabled: false },
            lineWidth: 0,
            gridLineWidth: 0,
            reversedStacks: false,
          },
          xAxis: {
            title: { text: null },
            labels: { enabled: false },
            lineWidth: 0,
            gridLineWidth: 0,
          },
          legend: {
            reversed: false,
            itemStyle: {
              fontFamily: FONT,
              fontSize: '12px',
              fontWeight: '500',
            },
          },
          // NOTE: the shared preset is applied last and spreads over these
          // options, so plotOptions.bar.dataLabels can't be overridden here —
          // the bar labels come from HORIZONTAL_STACKED_BAR_PRESET.
          tooltip: { pointFormat: '{series.name}: <b>{point.y}%</b>' },
        }}
      />
      {section.text && (
        <Text style={{ marginTop: 4, display: 'block' }}>{section.text}</Text>
      )}
    </Box>
  );
};
